import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { BillingPaymentsProvider } from '../../providers/billing-payments/billing-payments';
import { ToastProvider } from '../../providers/toast/toast';
import { UtilService } from '../../services/util';
import { TranslateService } from '@ngx-translate/core';

@IonicPage()
@Component({
  selector: 'page-billing-list',
  templateUrl: 'billing-list.html',
})
export class BillingListPage {

	bills = [];
  showData = false; 
  selRegistrationLogin : any;

  constructor(public navCtrl: NavController, 
    public navParams: NavParams, 
    private translate: TranslateService,
  	private bpProvider: BillingPaymentsProvider,
    private toast: ToastProvider,
    private util: UtilService) {

      this.selRegistrationLogin = localStorage.getItem('signup_login')

      if(this.selRegistrationLogin){
        this.showData = true
        this.toast.presentToast("You are Unauthorized to use this feature , Please request to admin.");
      }
    else{
  	bpProvider.getBillings().then(val => {
      this.bills = val;
      bpProvider.getBillTypes().then(val => {
        this.showData = true;
      });
  	}).catch(val => {
      this.showData = true;
    });
  }
  }

  openUrl(url:string){
    this.util.openWithInAppBrowser(url);
  }

  doRefresh(refresher) {
    if(this.selRegistrationLogin){
      setTimeout(() => {
        this.showData = true;
        refresher.complete() 
        },2000)
    }
    else{
    this.bpProvider.getBillings().then(val => {
      this.bills = val;
      refresher.complete();
    });
  }
  }

  billDateFormat(month: string){
    let bm = month.slice(4) + "-01"+ "-" + month.slice(0,4);
    return bm;
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad BillingListPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/billing-list/billing-list.ts